import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import InsertInvitationOutlined from '@mui/icons-material/InsertInvitationOutlined'
import TimerOutlined from '@mui/icons-material/TimerOutlined'
import CameraOutdoor from '@mui/icons-material/CameraOutdoor'
import Breadcrumb from 'src/components/Breadcrumb'
import Template from 'src/components/Template'
import { StyledContainer } from 'src/components/Layout/Styled'
import {
  convertDateRange,
  convertFormatTime,
  getQueryParams,
} from 'src/utils/lib'
import Content from './Content'
import DetailCard from './DetailCard'
import FixedHeader from './FixedHeader'
import { listBreadcrumbs } from './model'
import {
  StyledRowContent,
  StyledHalfColumn,
  StyledLabelIcon,
  StyledDivider,
  StyledRowTwo,
  StyledBlueBg,
} from './Styled'
import {
  fetchClassDetail,
  handleSocketResponse,
  checkExpiryQRCode,
} from './events'

import { handleErrorSocket } from './Enroll/InformationForm/event'

import { initSocketListener } from 'src/utils/lib'
import { handleResumeQueue } from 'src/redux/slices/queue/events'

const ClassDetail = () => {
  const params = useParams()
  const classUuid = _.get(params, 'trainingPlanUuid', '')
  const history = useHistory()
  const dispatch = useDispatch()
  const [socketId, setSocketId] = useState('')
  const enroll = getQueryParams('enroll')
  const secret = getQueryParams('secret')
  const qrExpired = useSelector(
    (state) => state.classDetail.qrExpired,
    shallowEqual
  )
  const callbackUrl = useSelector((state) => state.document.callbackUrl)

  useEffect(() => {
    const socket = initSocketListener({
      onMessage: (res, dispatch) =>
        dispatch(handleSocketResponse(res, classUuid)),
      onError: (res, dispatch) =>
        dispatch(handleErrorSocket(res.content, callbackUrl)),
      dispatch,
      onConnect: (id) => setSocketId(id), // ✅ สำคัญมาก
    })

    return () => {
      socket.disconnect()
    }
  }, [classUuid])

  const data = useSelector((state) => state.classDetail.data, shallowEqual)

  // เคยเข้าคิวคลาสนี้ไว้แล้วเปิดกลับเข้ามา -> เด้งกล่องรอคิวให้เหมือนเดิม
  // การถามลำดับ/สถานะเป็นระยะอยู่ใน components/QueueWaiting แล้ว ไม่ต้องมี timer ที่นี่อีก
  useEffect(() => {
    dispatch(handleResumeQueue(params))
  }, [classUuid])

  useEffect(() => {
    if (!_.isEmpty(socketId)) {
      if (enroll === 'auto' || !_.isEmpty(secret)) {
        dispatch(checkExpiryQRCode(params, socketId, enroll, history, secret))
      }
      if (!data) {
        dispatch(
          fetchClassDetail({
            params: params,
            socketId: socketId,
            enroll: enroll,
            qrExpired: qrExpired,
            history: history,
            secret: secret,
          })
        )
      }
    }
  }, [enroll, socketId, classUuid])

  return (
    <>
      <FixedHeader socketId={socketId} />

      <Template noMinHeight>
        <StyledContainer>
          <Breadcrumb list={listBreadcrumbs(_.get(params, 'uuid', ''))} />
          <DetailCard socketId={socketId} />
        </StyledContainer>
      </Template>

      <StyledBlueBg>
        <CourseRowContent />
      </StyledBlueBg>

      <Content />
    </>
  )
}

export default ClassDetail

export const CourseRowContent = () => {
  const data = useSelector((state) => state.classDetail.data, shallowEqual)
  const courseDetail = _.get(data, 'courseDetail', null)
  const trainingPlanData = _.get(data, 'trainingPlanData', null)
  const dateRange = convertDateRange(
    _.get(trainingPlanData, 'dateRangeMonthlyPlan', null)
  )
  const time = convertFormatTime(courseDetail)
  return (
    <StyledRowContent>
      <StyledRowTwo>
        <StyledHalfColumn>
          <StyledLabelIcon>
            <InsertInvitationOutlined fontSize="sm" />
            <Typography variant="body2">วันที่อบรม</Typography>
          </StyledLabelIcon>
          <Typography variant="h6">{dateRange}</Typography>
        </StyledHalfColumn>
        <StyledDivider />
        <StyledHalfColumn>
          <StyledLabelIcon>
            <TimerOutlined fontSize="sm" />
            <Typography variant="body2">ระยะเวลาของหลักสูตร</Typography>
          </StyledLabelIcon>
          <Typography variant="h6">{time}</Typography>
        </StyledHalfColumn>
      </StyledRowTwo>
      <StyledDivider id="training" />
      <StyledHalfColumn>
        <StyledLabelIcon>
          <CameraOutdoor fontSize="sm" />
          <Typography variant="body2">รูปแบบการสอน</Typography>
        </StyledLabelIcon>
        <Typography variant="h6">
          {_.get(courseDetail, 'trainingPlatformName', '-')}
        </Typography>
      </StyledHalfColumn>
    </StyledRowContent>
  )
}
